const base64 = require('base-64');
const utf8 = require('utf8');
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { AxiosRequestManager } from '../utils/AxiosRequestManager';

const base_url = window.location.origin + '/';
const ax: AxiosInstance = axios.create({
    baseURL: base_url, // Replace with your API base URL
    // timeout: 1000000, // Timeout of 10 seconds,
    headers: {
        "x-proxy-auth": process.env.REACT_APP_SECRET_KEY || "cd09c24b3f8a86a3619f7be2031f92ab822dc5fa9e9fdfb52b274fbf55e2a364c0ae75f5d395025cb1364574648dcfbfdccecdaf61a6b9ae78169ecc923f50b4"
    }
});
export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
    shouldCancelResponse?: boolean;  // Add custom flag to control canceling the response
}
// Add a request interceptor
ax.interceptors.request.use(
    (config: any) => {
        const controller = new AbortController();
        config.signal = controller.signal;
        const key = `${config.method}:${config.url}`;
        const nonCancellableUrls = ["exam_management/exam_report_draft",
            "master_data/get_questions_types",
            "/result/view-result","exam_management/exam_start"];
        const allowMultiple = nonCancellableUrls.some((endpoint: any) =>
            config.url.includes(endpoint)
        );
        // Abort previous request if it exists
        // const existingController = AxiosRequestManager.getControllers(key);
        // if (existingController) {
        //     existingController.abort();
        // }
        // Abort only if not in allowMultiple list
        if (!allowMultiple) {
            const existingControllers = AxiosRequestManager.getControllers(key);
            if (existingControllers) {
                existingControllers.forEach(c => c.abort());
            }
        }

        // Check if there is a stored username and password in localStorage
        const user = localStorage.getItem('username');
        const pass = localStorage.getItem('password');
        const text = user + ':' + pass;
        const bytes = utf8.encode(text);
        const token = base64.encode(bytes);

        const formDataEndpoints = ['menu/addcandidate', 'menu/intern_app_form', 'master_data/candidate_bulk_upload', 'create-account',
            'master_data/questions_bulk_upload', 'menu/generate_account', 'upload', 'submit-public-form', 'bulk-upload', 'question-bulk-upload'];
        if (!formDataEndpoints.some((endpoint) => config.url.includes(endpoint))) {
            if (
                !config.url.includes('auth/login') &&
                !config.url.includes('auth/password_reset') &&
                !config.url.includes('auth/reset-password/verify-token') &&
                !config.url.includes('auth/password_reset/confirm/') &&
                !config.url.includes('exam_management/examurl') &&
                !config.url.includes('auth/password_reset') &&
                !config.url.includes('exam_management/examsubmit') &&
                !config.url.includes('menu/public_account') &&
                !config.url.includes('menu/degree_list') &&
                !config.url.includes('exam_management/exam_report_draft') &&
                !config.url.includes('exam_management/question_auto_gen_section_all')&&
                !config.url.includes('exam_management/exam_start')
            ) {
                if (token) {
                    config.headers['Authorization'] = 'Basic ' + token;
                    config.headers['Content-Type'] = 'application/json';
                    config.headers['Accept'] = 'application/json';
                }
            } else {
                config.headers['Content-Type'] = 'application/json';
                config.headers['Accept'] = 'application/json';
            }
        } else {
            if (token && !config.url.includes('menu/intern_app_form')) {
                config.headers['Authorization'] = 'Basic ' + token;
            }
            // Only set Content-Type to multipart/form-data if the request data is FormData
            if (config.data instanceof FormData) {
                config.headers['Content-Type'] = 'multipart/form-data';
            } else {
                config.headers['Content-Type'] = 'application/json';
            }
            config.headers['Accept'] = 'application/json';
        }
        AxiosRequestManager.addController(key, controller, allowMultiple);
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to clean up the controller after request completion
ax.interceptors.response.use(
    (response) => {
        const key = `${response.config.method}:${response.config.url}`;
        AxiosRequestManager.removeController(key);  // Just cleanup
        return response;
    },
    (error) => {
        const key = `${error.config?.method}:${error.config?.url}`;
        AxiosRequestManager.removeController(key);  // Just cleanup
        return Promise.reject(error);
    }
);

// ax.interceptors.response.use(
//     (response) => {
//         const key = `${response.config.method}:${response.config.url}`;

//         // Here we manually abort the controller (canceling it after success)
//         const controller = AxiosRequestManager.getController(key);
//         if (controller) {
//             controller.abort(); // Cancel the request after success
//             console.log(`Request to ${key} has been canceled after successful response.`);
//         }
//         AxiosRequestManager.removeController(key);  // Clean up controller
//         return response;
//     },
//     (error) => {
//         const key = `${error.config.method}:${error.config.url}`;
//         AxiosRequestManager.removeController(key);  // Clean up controller
//         return Promise.reject(error);
//     }
// );
export default ax;
